import React from 'react';
import { Grid, Message } from 'semantic-ui-react';

/**
 * Placeholder for the Variation Selector Panel component
 * This will be replaced with the new variationWorksheet implementation
 * 
 * @returns {JSX.Element} VariationSelectorPanel component
 */
const VariationSelectorPanel = () => {
  return (
    <Grid.Column width={6}>
      <Message info>
        <Message.Header>Coming Soon</Message.Header>
        <p>
          The Variation Selector Panel feature is currently being reimplemented with an improved architecture.
          This feature will be available in a future update.
        </p>
      </Message>
    </Grid.Column>
  );
};

export default VariationSelectorPanel;
